import { isWeb } from '@/common/device-info';
import { isIOS, useResume as useFullContainerResume } from '@kibt/krn-utils';
import { useCallback, useEffect } from 'react';
import yoda from '@kibt/bridge';
import { useDebounceFn } from 'ahooks';

export function useResume(callback: Function, deps: React.DependencyList = []) {
    const _callback = useCallback(event => {
        callback(event);
    }, deps);

    const { run: debounceCallback } = useDebounceFn(
        event => {
            _callback(event);
        },
        { wait: 100 }
    );

    // 半屏resume
    useEffect(() => {
        const onHalfWebResume = () => {
            debounceCallback({ type: 'pageResume' });
        };

        yoda.event.addEventListener('half_web_resume' as any, onHalfWebResume);
        return () => {
            yoda.event.removeEventListener('half_web_resume' as any, onHalfWebResume);
        };
    }, []);

    // 全屏resume
    useFullContainerResume(
        event => {
            // RN端监听resume && event?.appState === 'show'
            if (!isWeb && event?.appState === 'show') {
                debounceCallback(event);
            }
            // android h5 resume event.type === 'pageResume'
            if (isWeb && event?.type === 'pageResume') {
                debounceCallback(event);
            }
            // ios h5 resume参数为空，无法区分类似android的 pageResume、 appResume
            if (isWeb && isIOS) {
                debounceCallback(event);
            }
        },
        [...deps]
    );
}
